import React from 'react';
import Header from '../componentes/Header';
import AnimacionPagina from '../componentes/AnimacionPagina';
import { motion } from 'framer-motion';
import { Link, useNavigate} from 'react-router';

import productosTejidosExclusivos from '../data/todosLosProductos/productosTejidosExclusivos';
import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import WhatsAppShareButton from '../componentes/WhatsAppShareButton';
import { Helmet } from 'react-helmet';
import Footer from '../componentes/Footer';

const PaginaTejidosExclusivos = () => {
    const navigate = useNavigate();
    return ( 

        <>
        <Helmet>
            <title>Tejidos Exclusivos | Hi Blinds</title>
            <meta name="description" content="Telas como Yute, Tahiiti, Simetry y más. Materiales únicos para un estilo sofisticado." />
            <meta property="og:title" content="Tejidos Exclusivos | Hi Blinds" />
            <meta property="og:description" content="Explora nuestra colección premium de tejidos con texturas y acabados exclusivos." />
            <meta property="og:url" content="https://hiblindsmx.com/tejidos-exclusivos" />
        </Helmet>
            <Header />
            <AnimacionPagina>
                <SectionProductos>
                    <h1>Tejidos Exclusivos</h1>
                    <BtnVolverAnim Ref='/' />
                    
                <ContainerProductos>
                    {productosTejidosExclusivos.map((producto, index) =>  {

                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer key={producto.id}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                             onClick={() => {
                              navigate(`/tejidos-exclusivos/${producto.slug}`);
                              }}
                              style={{ cursor: 'pointer' }}
                              >
                                <img 
                                loading='lazy' 
                                src={producto.images[0]}
                                alt={`${producto.nombre}`} 
                                />
                                <h4>{producto.nombre}</h4>
                                <p>Ancho:
                                    <br/> {producto.ancho}
                                </p>
                                <Link to={`/tejidos-exclusivos/${producto.slug}`}>
                                <button type='button'>Más información</button>
                               </Link>
                            </ProductoContainer>
                        </motion.div>
                     );
                 })}
                </ContainerProductos>
                    <BtnVolverAnim Ref='/' />
                    <WhatsAppShareButton message="¡Revisa nuestros Tejidos Exclusivos!" />
                </SectionProductos>
                <Footer />
            </AnimacionPagina>
            
        </>
     );
}

export default PaginaTejidosExclusivos;